import type { Dispatch, FC, SetStateAction } from 'react';
import React, { createContext, useContext, useMemo, useState } from 'react';

import type { PitDetailsFromRetailSessionContextType } from './types/PitDetailsFromRetailSessionTypes';

const defaultValue = {
  pitDetailsInRetailSession: undefined,
  setPitDetailsInRetailSession: () => {},
  resetPitDetailsInRetailSession: () => {},
};

export const PitDetailsFromRetailSessionContext = createContext<{
  pitDetailsInRetailSession: PitDetailsFromRetailSessionContextType | undefined;
  setPitDetailsInRetailSession: Dispatch<
    SetStateAction<PitDetailsFromRetailSessionContextType | undefined>
  >;
  resetPitDetailsInRetailSession: () => void;
}>(defaultValue);

const PitDetailsFromRetailSession: FC = ({ children }) => {
  const [pitDetailsInRetailSession, setPitDetailsInRetailSession] =
    useState<PitDetailsFromRetailSessionContextType>();

  const resetPitDetailsInRetailSession = () => {
    setPitDetailsInRetailSession(undefined);
  };

  const value = useMemo(
    () => ({
      pitDetailsInRetailSession,
      setPitDetailsInRetailSession,
      resetPitDetailsInRetailSession,
    }),
    [pitDetailsInRetailSession, setPitDetailsInRetailSession]
  );

  return (
    <PitDetailsFromRetailSessionContext.Provider value={value}>
      {children}
    </PitDetailsFromRetailSessionContext.Provider>
  );
};

export default PitDetailsFromRetailSession;

export const usePitDetailsFromRetailSessionProvider = () => {
  return useContext(PitDetailsFromRetailSessionContext);
};
